import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change, getFormSyncErrors } from 'redux-form';
import ChangeDeliveryDialog from './NewPurchaseOrderDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as purchaseOrdersSelectors, actions as purchaseOrdersActions } from 'ducks/purchaseOrders/purchaseOrders';
import { selectors as staffSelectors } from 'ducks/staff';
import { selectors as formSelectors } from 'ducks/form';

const params = new URLSearchParams(location.search);
const FORM_NAME = 'LoadPurchaseOrderForm';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty(FORM_NAME)(state),
  values: getFormValues(FORM_NAME)(state),
  isValid: isValid(FORM_NAME)(state),
  formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
  selectedPurchaseOrder: purchaseOrdersSelectors.selected(state)?.PurchaseOrder ?? params.get('PurchaseOrder'),
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : '',
  currentWarehouse: staffSelectors.defaultWarehouseEntity(state) ?? '',
  formAsyncErrors: formSelectors.getFormAsyncErrors(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset(FORM_NAME),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change(FORM_NAME, fieldName, fieldValue),
    searchById: purchaseOrdersActions.searchById,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChangeDeliveryDialog);
